import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M887.132284 833.893244 560.497039 507.257999l320.308143-320.314283c12.085246-12.087293 12.085246-31.670304 0-43.756573-12.08627-12.085246-31.68463-12.085246-43.756573 0L516.740466 463.500403l-326.639339-326.640362c-12.025894-12.025894-31.535227-12.025894-43.561122 0-12.040221 12.025894-12.040221 31.54853 0 43.575448l326.633199 326.633199L136.905578 843.339384c-12.079106 12.08627-12.079106 31.668257 0 43.754526 12.08627 12.087293 31.677467 12.087293 43.763736 0l336.261487-336.266603 326.642408 326.642408c12.025894 12.025894 31.518854 12.025894 43.559075 0C899.159202 865.442798 899.159202 845.919139 887.132284 833.893244z\" p-id=\"2132\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close.svg
// module id = toIl
// module chunks = 76